import {CONFIG} from '@/config';
import {AxiosError, AxiosResponse} from 'axios';
import {httpService} from '@/services/http.service';
import {ServiceHelper} from '@/utils/service.helper';
import { DataSourceType } from '@/enums/data-source-type.enum';
import {NameValue, NameValues} from '@/modules/neodash/model/types/interfaces/NameValue';

const toNameValue = r => r.map(lt => ({name: lt.text, value: lt.value} as NameValue));
export class DncCommonService{
  static baseUrl = `${CONFIG.URL.NEODASH_API}/api/dnc`;
  static projectUrl = `${DncCommonService.baseUrl}/project`;

  public static getLocaleTypes = (): Promise<NameValues> =>
    ServiceHelper.mapToPromise<any[]>(`${DncCommonService.baseUrl}/localeType/all`).then(toNameValue);

  public static getLocaleTypesAboveCity = (): Promise<NameValues> =>
    ServiceHelper.mapToPromise<any[]>(`${DncCommonService.baseUrl}/localeType/aboveCity`).then(toNameValue);

  public static getDNCType = (): Promise<boolean> =>
    ServiceHelper.mapToPromise<boolean>(`${DncCommonService.baseUrl}/dncType`);

  public static getDNCLocaleTypes = async (projectDataSource: DataSourceType) : Promise<NameValues> => {
    const { getLocaleTypes } = DncCommonService;
    return await getLocaleTypes();
  };

  public static downloadExtractDnc(url: string) {
    return new Promise<void>((resolve, reject) => {
      httpService.httpBlob.get(url)
        .then((res: AxiosResponse) => {
          const blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          kendo.saveAs({
            dataURI: window.URL.createObjectURL(blob),
            fileName: res
              .headers['content-disposition']
              .substring(21, res.headers['content-disposition'].length)
          });
          resolve();
        })
        .catch((err: AxiosError) => {
          reject();
          console.log(err.message);
        });
    })
  }
}
